import { CoreOperation } from "../../../core/index.js";
import { SET_USE_KEY_VALUE_FOR_LANG_STRING } from "../vocabulary.js";
export class DataPsmSetUseKeyValueForLangString extends CoreOperation {
    static TYPE = SET_USE_KEY_VALUE_FOR_LANG_STRING;
    dataPsmProperty = null;
    useKeyValueForLangString = false;
    constructor() {
        super();
        this.types.push(DataPsmSetUseKeyValueForLangString.TYPE);
    }
    static is(resource) {
        return resource?.types.includes(DataPsmSetUseKeyValueForLangString.TYPE);
    }
}
//# sourceMappingURL=data-psm-set-use-key-value-for-lang-string.js.map